// https://lucidlink.atlassian.net/browse/LUCID-21722
export const timestampToISOString = (timestamp) => new Date(timestamp).toISOString();
export const timestampToDateString = (timestamp) => {
    const date = new Date(timestamp);
    const day = prefixWithZeroes(date.getDate(), 2);
    const month = prefixWithZeroes(date.getMonth(), 2);
    const year = prefixWithZeroes(date.getFullYear(), 4);
    return `${day}/${month}/${year}`;
};
export const timestampToTimeString = (timestamp) => {
    const date = new Date(timestamp);
    const hours = prefixWithZeroes(date.getHours(), 2);
    const minutes = prefixWithZeroes(date.getMinutes(), 2);
    const seconds = prefixWithZeroes(date.getSeconds(), 2);
    const milliseconds = prefixWithZeroes(date.getMilliseconds(), 3);
    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
};
const prefixWithZeroes = (number, maxZeroes) => number.toString().padStart(maxZeroes, '0');
